import React, { useState, useEffect } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './Gallery.css';

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      const response = await fetch('http://localhost:3001/api/gallery');
      const data = await response.json();
      
      if (data.success && data.images) {
        // Transform backend data to match component structure
        const transformedImages = data.images.map(img => ({
          id: img.id,
          src: img.imageUrl,
          caption: img.title || 'Gallery image'
        }));
        setGalleryImages(transformedImages);
      }
    } catch (error) {
      console.error('Failed to fetch gallery:', error);
      // Keep empty array if fetch fails
    } finally {
      setLoading(false);
    }
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
  };

  if (loading) {
    return (
      <section className="gallery" id="gallery">
        <div className="section-title-wrapper">
          <h2 className="section-title">Gallery</h2>
        </div>
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>Loading gallery...</p>
      </section>
    );
  }

  if (galleryImages.length === 0) {
    return (
      <section className="gallery" id="gallery">
        <div className="section-title-wrapper">
          <h2 className="section-title">Gallery</h2>
        </div>
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>No images in gallery yet.</p>
      </section>
    );
  }

  return (
    <section className="gallery" id="gallery">
      <div className="section-title-wrapper">
        <h2 className="section-title">Gallery</h2>
      </div>

      <div className="gallery-viewer">
        <button className="gallery-nav-btn left" onClick={handlePrev}>
          <FiChevronLeft size={24} color="#FFC501" />
        </button>

        <div className="gallery-main">
          {/* Main Display */}
          <div className="gallery-display">
            <img
              src={`http://localhost:3001${galleryImages[currentIndex].src}`}
              alt={galleryImages[currentIndex].caption}
            />
            <div className="gallery-caption-bar">
              <span className="gallery-caption">{galleryImages[currentIndex].caption}</span>
            </div>
          </div>

          {/* Thumbnail Strip */}
          <div className="gallery-thumbnails">
            {galleryImages.map((img, index) => (
              <div
                key={img.id}
                className={`gallery-thumb ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              >
                <img
                  src={`http://localhost:3001${img.src}`}
                  alt={img.caption}
                />
              </div>
            ))}
          </div>
        </div>

        <button className="gallery-nav-btn right" onClick={handleNext}>
          <FiChevronRight size={24} color="#FFC501" />
        </button>
      </div>

      <div className="gallery-view-btn-wrapper">
        <a href="#gallery" className="gallery-view-btn">View Gallery</a>
      </div>
    </section>
  );
};

export default Gallery;
